<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (tap)="confirmCancel()">
                <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>{{title}}</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content *ngIf="!documentTemp">
    <div>
        <div class="ion-padding custom-skeleton">
            <ion-skeleton-text animated style="width: 60%"></ion-skeleton-text>
            <ion-skeleton-text animated></ion-skeleton-text>
            <ion-skeleton-text animated style="width: 88%"></ion-skeleton-text>
            <ion-skeleton-text animated style="width: 70%"></ion-skeleton-text>
            <ion-skeleton-text animated style="width: 60%"></ion-skeleton-text>
        </div>
    </div>
</ion-content>

<ion-content *ngIf="documentTemp">
    <customer-return [document]="documentTemp"></customer-return>
    <!--site *ngIf="documentTemp.site.name" [document]="documentTemp"></site-->
    <site [document]="documentTemp"></site>
    
    <contactdetails [document]="documentTemp"></contactdetails>
    <items *ngIf="documentTemp.originalDocumentType === 1" [document]="documentTemp"></items>
    <items-return *ngIf="documentTemp.originalDocumentType !== 1" [document]="documentTemp"></items-return>
    <picturestaken [document]="documentTemp" *ngIf="!counterSigningMode"></picturestaken>
    <app-signature [document]="documentTemp" *ngIf="!counterSigningMode"></app-signature>
    <comments [document]="documentTemp"></comments>

    <ion-fab vertical="bottom" horizontal="end" slot="fixed" *ngIf="!counterSigningMode">
        <ion-fab-button (tap)="saveSignedDocument()" color="success">
            <ion-icon name="checkmark"></ion-icon>
        </ion-fab-button>
    </ion-fab>
</ion-content>
